import $http from '$http'
import {
    util
} from 'utils';
import {
    lg
} from 'utils';

export default {
    methods: {
        getList() {
            this.changeFlag();
            let obj = this.form;
            if (this.isSchoolTrain) {
                obj.SchoolCome = 6 //判断是培训幼儿
            } else {
                //obj.SchoolCome = this.SchoolCome
            }
            if (obj.createTimeStart != "" && obj.createTimeStart != undefined) {
                obj.createTimeStart = new Date(obj.createTimeStart).toLocaleDateString();
            }
            if (obj.createTimeEnd != "" && obj.createTimeEnd != undefined) {
                obj.createTimeEnd = new Date(obj.createTimeEnd).toLocaleDateString();
            };

            var props = {};

            for (var p in obj) {
                if (obj[p] !== "") {
                    props[p] = obj[p];
                    Object.assign({}, props)
                }
            };

            this.lists = [];
            this.loading = true; //拼命加载中显示
            let Params = Object.assign({}, {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            }, props);

            $http.get("api/School/ZqwPlatform_GetFormatList", Params).then(res => {

                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;

                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false; //拼命加载中显示

                    this.lists = Data;

                    for (let i = 0; i < this.lists.length; i++) {
                        this.lists[i].Name = this.lists[i].AgentCustomerName
                        // + '(' + this.lists[i].C_name + ')'
                        //console.log(this.lists[i].name)
                    }
                    for (let i = 0; i < this.lists.length; i++) {
                        this.lists[i].CreateTime = util.time2str(new Date(this.lists[i].CreateTime), "short");
                        this.lists[i].AuditTime = util.time2str(new Date(this.lists[i].AuditTime), "short")
                    }
                });
            });
        },
        open(Params) {
            $http.get("api/School/OpenOL", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "联帮在线开通成功",
                        type: "success"
                    });
                    this.getList();
                })
            })
        },
        close(Params) {
            $http.get("api/School/CloseOL", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "联帮在线关闭成功",
                        type: "success"
                    });
                    this.getList();
                })
            })
        },
        getClassList(Params) {
            $http.get("/api/Class/ZqwPlatform_GetClassList", Params).then(res => {

                util.doResult(this, res, () => {
                    let {
                        Data,
                        Cnt
                    } = res.data;
                    this.ClassList = Data;
                    for (var i = 0; i < this.ClassList.length; i++) {
                        for (var j = 0; j < this.GradeList.length; j++) {
                            if (this.ClassList[i].GradeName == this.GradeList[j].id) {
                                this.ClassList[i].GradeName = this.GradeList[j].text;
                            }
                        }
                    }
                    this.TtotalSize = Cnt;
                });
            });
        },
        getSubjectList() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            }
            $http.get("api/School/GetSubjectList", Params).then(res => {
                util.doResult(this, res, () => {
                    let {
                        Data
                    } = res.data;
                    this.SubjectList = Data;
                })
            })
        },
        ActionclassSubmit(Params) {
            this.addbjbtndisabled = true;
            $http.post("/api/Class/ZqwPlatform_EditClass", Params).then(res => {
                this.addbjbtndisabled = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "添加班级成功",
                        type: "success"
                    });
                    var a = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        SchoolId: this.CurrentRowId
                    };
                    this.getClassList(a);
                    this.classDialogClose();
                });
            })
        },
        ActiongetOneClass(Params) {
            $http.get("/api/Class/ZqwPlatform_GetClassModel", Params).then(res => {
                util.doResult(this, res, () => {});
                let {
                    Data
                } = res.data;
                // this.classform.SN = Data.SN;
                // this.classform.MAC = Data.MAC;
                if (Data.OptionSwitch == 0) {
                    this.classform.Option = false;
                } else {
                    this.classform.Option = true;
                }
                this.ActionSubject = Data.SubjectHtml.split(",");
                for (var i = 0; i < this.ActionSubject.length; i++) {
                    this.ActionSubject[i] = parseInt(this.ActionSubject[i])
                }
                for (var i = 0; i < this.GradeList.length; i++) {
                    if (this.GradeList[i].text == Data.Grade) {
                        this.classform.Grade = this.GradeList[i].id;
                    }
                }
                this.classform.ClassNick = Data.ClassNick;
                this.classform.ClassName = Data.ClassName;
                this.classform.Id = Data.ClassId;
                this.classform.ProjectType = Data.ProjectType;
                this.classform.PolicyType = Data.PolicyType;
                this.classform.IsSchedule = Data.IsSchedule;

                if (Data.ProjectType == 2 || Data.ProjectType == 4) {
                    this.classform.selectedOptions = [this.classform.ProjectType.toString(), this.classform.PolicyType.toString()]
                } else {
                    this.classform.selectedOptions = [this.classform.ProjectType.toString()]
                }

            })
        },
        ActionDelClass(Params) {
            $http.get("api/Class/ZqwPlatform_GetOneSchoolHardList", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "删除成功",
                        type: "success"
                    });
                    var a = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        SchoolId: this.CurrentRowId
                    };
                    this.getClassList(a);
                })
            })
        },

        ActiondelTeacher(Params) {
            $http.get("api/Class/ZqwPlatform_DelClassMainTeacher", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "删除班主任成功",
                        type: "success"
                    });
                    var a = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        SchoolId: this.CurrentRowId
                    };
                    this.getClassList(a);
                })
            })
        },
        ActionAddTeacher(Params) {
            $http.get("/api/Class/ZqwPlatform_ClassMainTeacher", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "设置班主任成功",
                        type: "success"
                    });
                    var a = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        SchoolId: this.CurrentRowId
                    };
                    this.getClassList(a);
                    this.TeacherDialogClose();
                })
            })
        },
        getFollowList(options) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: options.pageIndex || 1,
                pageSize: options.pageSize || 10,
                Customer_Id: options.id
            };
            $http.get('api/Follow/GetFollowList', Params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.followUpTotalSize = Cnt;
                    this.followUpList = Data;
                });
            });
        },
        addFollowUpItem(data) {
            data.Customer_Id = this.currentId;
            $http.post('api/Follow/AddFollowEx', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //获取跟进内容详情
        getFollowUpItem(id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: id
            };
            $http.get('api/Follow/GetFollowById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.followItem = Data;
                });
            });
        },
        //更新跟进内容详情
        updateFollowUpItem(data) {
            $http.post('api/Follow/Follow_UpdateEx', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //删除跟进内容
        delFollowUpItem(id) {
            $http.post('api/Follow/DelFollow', {
                Id: id
            }).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        // 重置密码
        ReSetPassword(SchoolId) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: SchoolId
            };
            $http.get('api/School/ReSetPassword', Params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '重置成功！',
                        type: 'success'
                    });
                    this.getFollowList({
                        id: this.currentId
                    });
                });
            });
        },
    },
}


// WEBPACK FOOTER //
// ./src/pages/school/officialSchool/services.js